import Enemy from './Enemy';
import resourcesLoader from '../common/resourcesLoader';
import config from '../common/config';
import {randomInteger} from '../common/commonFunctions';
import flyingEnemy from '../../images/flyingEnemy.png';
import standingEnemy from '../../images/standingEnemy.png';
import walkingEnemy from '../../images/walkingEnemy.png';

resourcesLoader.add({
    flyingEnemy,
    standingEnemy,
    walkingEnemy
});

function EnemyFactory(bottomLine, canvasWidth) {
    this.bottomLine = bottomLine;
    this.canvasWidth = canvasWidth;
}

EnemyFactory.prototype = {
    constructor: EnemyFactory,

    makeWalkingEnemy() {
        const img = resourcesLoader.get('walkingEnemy');
        const posX = this.canvasWidth + config.walkingEnemyWidth;
        const posY = this.bottomLine - config.walkingEnemyHeight;
        return new Enemy(img, posX, posY, -config.walkingEnemySpeed, 0, config.walkingEnemyWidth, config.walkingEnemyHeight, config.walkingEnemyAnimationSpeed);
    },
    makeStandingEnemy() {
        const img = resourcesLoader.get('standingEnemy');
        const posX = this.canvasWidth + config.standingEnemyWidth;
        const posY = this.bottomLine - config.standingEnemyHeight;
        return new Enemy(img, posX, posY, -config.standingEnemySpeed, 0, config.standingEnemyWidth, config.standingEnemyHeight);
    },
    makeFlyingEnemy() {
        const img = resourcesLoader.get('flyingEnemy');
        const posX = this.canvasWidth + config.flyingEnemyWidth;
        const posY = randomInteger(0, this.bottomLine - config.flyingEnemyHeight);
        return new Enemy(img, posX, posY, -config.flyingEnemySpeed, 0, config.flyingEnemyWidth, config.flyingEnemyHeight, config.flyingEnemyAnimationSpeed);
    }
}

export default EnemyFactory;